export const WIRE_VERSION = '1';

export type AccessLevel = 'owner' | 'contributor' | 'viewer';

export const ACCESS_LEVEL_TO_INT: Record<AccessLevel, number> = {
  owner: 0,
  contributor: 1,
  viewer: 2,
};

export type AggregateOperation = 'write' | 'create' | 'trim' | 'delete';

export interface WireEvent {
  client_seq: number;
  event_seq: number;
  event_timestamp: number;
  event_type_major: number;
  event_type_minor: number;
  iv?: string;
  event_value: string;
  /**
   * Optional request-level idempotency id (gateway >= 0.1.1, WIRE-CONTRACT §events). On WRITE:
   * a canonical hyphenated UUID string. On READ: standard padded base64 of the UUID's 16 bytes
   * (the id encoding) — compare via `uuidToWireEventId`. Absent on events written without one.
   */
  event_id?: string;
}

export interface EventBatch {
  aggregateVersion: number;
  serverTimestamp: number;
  clientId: string;
  userId?: string;
  events: WireEvent[];
}

export interface WriteResult {
  aggregateVersion: number;
  writeBackoffMs?: number;
}

export interface ShareResult {
  shareKey: string;
}

export interface DeleteResult {
  serverTimestamp: number;
}

// One entry from the `/index` list: the addressable wire ids the caller passes back to
// `aggregate(type, id)`. Not the hashed path ids; those are one-way.
export interface AggregateRef {
  aggregateType: string;
  aggregateId: string;
}

export interface AggregateChange {
  aggregateId: string;
  operation: AggregateOperation;
  fromVersion?: number;
  toVersion?: number;
  keepFromVersion?: number;
}

export interface AuthCredentials {
  publicKey: string;
  signature: string;
  bearerToken?: string;
}

export type AuthProvider = (nonce: string) => Promise<AuthCredentials>;

export interface RetryPolicy {
  maxAttempts: number;
  defaultBackoffMs: number;
}

export const DEFAULT_RETRY: RetryPolicy = {
  maxAttempts: 2,
  defaultBackoffMs: 1000,
};
